module.exports = __webpack_public_path__ + "static/media/5. En calma, Acrílico en tela, 190 x 190 cm, 2014 copy.f5d6dbec.png";